// organisms/ModalSidebar/ModalSidebar.tsx
import * as React from 'react';
import { Box, useTheme } from '@mui/material';
import './ModalSidebar.css';
import { ModalMenuItemProps } from '../../molecules/ModalMenuItem';
import { ModalMenuItems } from '../ModalMenuItems';
import { ModalSidebarAction, type ModalSidebarActionProps } from '../ModalSidebarAction';

export type ModalSidebarProps = {
    actions?: ModalSidebarActionProps[];
    items: ModalMenuItemProps[];
    defaultActiveId?: string;
};

export const ModalSidebar: React.FunctionComponent<ModalSidebarProps> = function (props) {
    const { actions = [], items = [] } = props;
    const theme = useTheme();
    const bgColor = theme.palette.grey[200];
    const classNames = ['modal-sidebar'];

    return (
        <Box
            data-testid="modal-sidebar"
            className={classNames.join(' ')}
            sx={{ backgroundColor: bgColor }}
        >
            {actions.map((action: ModalSidebarActionProps) => (
                <ModalSidebarAction
                    key={action.label}
                    {...action}
                />
            ))}
            <ModalMenuItems menuItems={items} />
        </Box>
    );
};
